import {SelectChangeEvent, SelectChangeEventPayload} from "../../../events/Events";
import {EventBus} from "../../../events/EventBus";

const eventBus = EventBus.getInstance();

export function onChangeFor(id: string, callback: (payload: SelectChangeEventPayload) => void) {
    eventBus.subscribe(SelectChangeEvent.TYPE, (event) => {
        const payload: SelectChangeEventPayload = (event as SelectChangeEvent).payload;
        if (payload.id.startsWith(id)) {
            callback(payload);
        }
    });
}
